import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.25 9h-1.5V.75a.75.75 0 0 0-1.5 0V9H.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5m13.5 3h-1.5V.75a.75.75 0 0 0-1.5 0V12h-1.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5m-9 6a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-1.5 0v9c0 .414.336.75.75.75m6-2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zm-13.5-3a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0zM10.5 4.5H12A.75.75 0 0 1 12 6H7.5a.75.75 0 0 1 0-1.5H9V.75a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }